import { noAuthGuard } from '@/shareds/router-guards';
import { RouteConfig } from 'vue-router';

const rotasDeCarrinhoDoCliente: RouteConfig[] = [
	{
		path: '/carrinho/:identificador',
		name: 'Carrinho',
		component: () => 
			import('@/views/application/pedidos/TelaDoCarrinhoDoCliente.vue'),
		beforeEnter: noAuthGuard,
	},
]

export default rotasDeCarrinhoDoCliente